import type { CanvasContexts } from '@/modules/map-editor';

export function updateCanvasSize(
  ctx: CanvasRenderingContext2D | null,
  pixelRatio: number = window.devicePixelRatio
): void {
  if (!ctx) return;

  ctx.canvas.width = ctx.canvas.clientWidth * pixelRatio;
  ctx.canvas.height = ctx.canvas.clientHeight * pixelRatio;
}

export function clearCanvas(
  ctx: CanvasRenderingContext2D | null,
  pixelRatio: number = window.devicePixelRatio
): void {
  if (!ctx) return;

  const windowWidth = window.innerWidth * pixelRatio;
  const windowHeight = window.innerHeight * pixelRatio;

  ctx.clearRect(0, 0, windowWidth, windowHeight);
}

export function resizeAllCanvases(
  contexts: CanvasContexts,
  pixelRatio: number = window.devicePixelRatio
): void {
  for (const contextKey in contexts) {
    const ctx = contexts[contextKey as keyof CanvasContexts];
    updateCanvasSize(ctx, pixelRatio);
  }
}

export function clearAllCanvases(
  contexts: CanvasContexts,
  pixelRatio: number = window.devicePixelRatio
): void {
  for (const contextKey in contexts) {
    const ctx = contexts[contextKey as keyof CanvasContexts];
    clearCanvas(ctx, pixelRatio);
  }
}

export function initOffscreenCanvas(
  mainCanvas: HTMLCanvasElement,
  pixelRatio: number = window.devicePixelRatio
): HTMLCanvasElement {
  const offscreenCanvas = document.createElement('canvas');
  offscreenCanvas.width = mainCanvas.clientWidth * pixelRatio;
  offscreenCanvas.height = mainCanvas.clientHeight * pixelRatio;

  return offscreenCanvas;
}

export function getCanvasContexts(
  canvasMain: HTMLCanvasElement | null,
  canvasHighlights: HTMLCanvasElement | null,
  canvasBuffered: HTMLCanvasElement | null
): CanvasContexts {
  return {
    ctx: canvasMain?.getContext('2d') || null,
    ctxHighlights: canvasHighlights?.getContext('2d') || null,
    ctxBuffered: canvasBuffered?.getContext('2d') || null
  };
}

export function isValidContext(
  ctx: CanvasRenderingContext2D | null
): ctx is CanvasRenderingContext2D {
  return ctx !== null;
}

export function getCanvasDimensions(
  canvas: HTMLCanvasElement,
  pixelRatio: number = window.devicePixelRatio
): { width: number; height: number } {
  return {
    width: canvas.clientWidth * pixelRatio,
    height: canvas.clientHeight * pixelRatio
  };
}
